export const aboutSection = {
  kicker: 'О форуме',
  titleLines: ['Реальные', 'кейсы для решения', 'бизнес задач'],
  titleTablet: 'Реальные кейсы для решения бизнес задач',
  description: [
    { text: 'Форум для ' },
    { text: 'собственников и управленцев малого и среднего бизнеса', accent: true },
    { text: ' в сфере розничной, оптовой торговли и сервиса.' }
  ],
  action: null,
  stats: [
    {
      iconSrc: '/icons/about-icon-speakers.svg',
      value: '7',
      suffix: '+',
      label: ['Спикеров']
    },
    {
      iconSrc: '/icons/about-icon-participants.svg',
      prefix: 'до',
      value: '250',
      label: ['Участников']
    },
    {
      iconSrc: '/icons/about-icon-cases.svg',
      value: '10',
      suffix: '+',
      label: ['Реальных', 'кейсов']
    },
    {
      iconSrc: '/icons/about-icon-content-hours.svg',
      value: '6',
      suffix: '+',
      label: ['Часов', 'контента']
    }
  ]
};
